import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import DrawerToggleButton from "ui/SideDrawer/DrawerToggleButton";
import "ui/NavBar/NavBar.css";
import GlobalContext from "contexts/context";

// https://www.youtube.com/watch?v=l6nmysZKHFU

const NavBar = (props) => {
  const { globalState } = useContext(GlobalContext);
  // hooks must ONLY be called at top level in the function
  // Anything here acts as componentWillMount

  useEffect(() => {
    // This runs after component is rendered ... every time
    console.log("NavBar component rendered");
  });

  useEffect(() => {
    // This runs after component is rendered ... first time. The [] indicates "no dependencies"
    // so this is like componentDidMount
    console.log("NavBar component is rendered ... first time");
    return () => {
      console.log(
        "NavBar component runs componentWillUnmount for the last time"
      );
    };
  }, []);

  useEffect(() => {
    // this is like componentDidUpdate
    console.log("NavBar componentDidUpdate because props changed", props);

    return () => {
      // this is like componentWillUnmount
      console.log("NavBar componentWillUnmount because props changed");
    };
  }, [props]);

  let content = (
    <header className="navbar">
      <nav className="navbar__navigation">
        <div className="navbar__toggle-button">
          <DrawerToggleButton click={props.toggleDrawer} />
        </div>
        <div className="navbar__logo">
          <Link to="/">
            <li>enabled.WORLD</li>
          </Link>
        </div>
        <div className="navbar__version">{globalState.version}</div>
        <div className="spacer" />
        <div className="navbar__navigation__items">
          <ul>
            <Link to="/">
              <li>Go to Topic list</li>
            </Link>
            {/* <Link to="/UI2">
              <li>Go to UI2</li>
            </Link> */}
          </ul>
        </div>
      </nav>
    </header>
  );

  return content;
};

// memo acts like shouldComponentUpdate ... can use without the function, or with a function that returns false if it SHOULD rerender
export default React.memo(NavBar, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
